import { FIELD_TYPES } from "constants/template-field-type";

export default {
  boardIdAndToken: { type: FIELD_TYPES.TEXT, label: "Board id and token" },
  tooltipText: { type: FIELD_TYPES.TEXT, label: "Tooltip text", translatable: true }
};
